import qs from 'query-string'
import { linkSchema } from '../schemas'
import { withParsedData } from './base'

export const LinkRenderer = withParsedData(linkSchema)(({ parsedData }) => {
  const { type, href, params, text, ...rest } = parsedData
  const url = qs.stringifyUrl({ url: href, query: params })
  return (
    <a href={url} {...rest}>
      {text}
    </a>
  )
})
